export enum EInsightsIANameMonth {
  JANEIRO = 1,
  FEVEREIRO = 2,
  MARÇO = 3,
  ABRIL = 4,
  MAIO = 5,
  JUNHO = 6,
  JULHO = 7,
  AGOSTO = 8,
  SETEMBRO = 9,
  OUTUBRO = 10,
  NOVEMBRO = 11,
  DEZEMBRO = 12
}

export const handleNameDate = (date: string) => {
  const [year, month] = date.split("-");
  const monthIndex = Number(month);

  return `${EInsightsIANameMonth[monthIndex]} ${year}`;
};
